<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wcAjH9/tc-custom/9780061868221.jpg?1731838250051" alt="This image is the cover for the book In the Garden of the North American Martyrs"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">In the Garden of the North American Martyrs
      </h1>
      <p class="bookDescription body article font2">
        <b>A collection from the Story Prize and PEN/Faulkner Award winner and author of <i>This Boy’s Life, </i>“a writer of the highest order” (<i>Los Angeles Times</i>).</b><br/><br/>Among the characters you’ll find in this collection of twelve stories by Tobias Wolff are a teenage boy who tells morbid lies about his home life; a timid professor who, in the first genuine outburst of her life, pours out her opinions in spite of a protesting audience; a prudish loner who gives an obnoxious hitchhiker a ride; and an elderly couple on a golden anniversary cruise who endure the offensive conviviality of the ship’s social director.<br/><br/>Fondly yet sharply drawn, Wolff’s characters stumble over each other in their baffled yet resolute search for the “right path” in this collection that the <i>San Francisco Chronicle</i> called “one of the most impressive debuts in recent memory.”<br/><br/>“Tobias Wolff is a captivating, brilliant writer, one of the best we’ve got.” —Annie Dillard<br/><br/>“A masterful storyteller, a natural raconteur.” —Michiko Kakutani<br/><br/>“I have not read a book of stories in years that has given me such a shock of amazement and recognition—and such pleasure.” —Raymond Carver
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tobias Wolff
      </h2>
      
      <p class="authorDescription body article"><P>Tobias Wolff was born in Birmingham, Alabama, and grew up in Washington State. He attended Oxford University and Stanford University, where he now teaches English and creative writing. He has received the Story Prize, both the Rea Award and PEN/Malamud Award for excellence in the short story, the <I>Los Angeles Times</I> Book Award, and the PEN/Faulkner Award.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b5203cba